import { keyBy } from 'lodash-es'

import { managementMenusMap } from '@/_blocks/Managements/_data/menus'
import { usePermission } from '@/_blocks/Managements/_hooks/usePermission'
import { CssIcon } from '@/components/CssIcon'


import { useRouter } from '@/hooks/routes';
import { tw, cls } from 'tagged-classnames-free';
interface IWebMenuEntryProps {
  className?: string
}
const WebMenuEntry = (props: IWebMenuEntryProps) => {
  const { className } = props

  const { hasDebugPermission, pagePermissions, hasSuperAdminPermission } =
    usePermission()

  const router = useRouter()

  const handleClick = () => {
    const menuList = Object.values(managementMenusMap)
    if (pagePermissions.length && menuList.length) {
      let href: string | undefined
      if (hasSuperAdminPermission) {
        href = menuList[0].href
      } else {
        const permissionMap = keyBy(pagePermissions, 'permissionName')
        href = menuList.find((v) => permissionMap[v.permission])?.href
      }
      if (href) {
        router.push(href)
      }
    }
  }

  return hasDebugPermission ? (
    <div
      className={tw`
        text-f-text hover:text-f-primary flex w-fit cursor-pointer items-center gap-x-1 px-2 py-1 text-sm ${className}
      `}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        handleClick()
      }}
    >
      <CssIcon className={cls`i-com--setting size-4`} />
      <span>Management</span>
    </div>
  ) : null
}

export default WebMenuEntry
